<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-poll"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Projeção de BRR
        </div>
      </template>
      <v-btn
        id="btn-nova-projecao-brr"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float:left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon
          left
          size="30px"
        >
          mdi-plus-circle
        </v-icon>
        Nova Projeção
      </v-btn>
      <v-text-field
        id="projecao-brr-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars
        class="mt-11"
        :items="downloadProgressData"
        prefix-text="Baixando Projeção de BRR"
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="item"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhuma Projeção de BRR disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.titulo`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="text-truncate-column"
                v-bind="attrs"
                v-on="on"
              >
                {{ item.titulo }}
              </div>
            </template>
            <span>{{ item.titulo }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-projecao-brr"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="(downloadProgressData[item.id] !== undefined) ? true : false"
            :disabled="item.status != 'SUCESSO'"
            @click="downloadItem(item)"
          >
            <v-icon small>
              mdi-download
            </v-icon>
          </v-btn>
          <v-btn
            id="action-edit-projecao-brr"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-projecao-brr"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>
                  mdi mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item 
                v-if="canRunItem(item)"
                @click="executarItem(item.id)"
              >
                <v-list-item-title>
                  <v-icon small>
                    mdi-play
                  </v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="duplicarItem(item.id)"
              >
                <v-list-item-title>
                  <v-icon
                    small
                  >
                    mdi-content-copy
                  </v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="openDialogDelete(item.id, item.titulo)"
              >
                <v-list-item-title>
                  <v-icon small>
                    mdi-trash-can-outline
                  </v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="openDialogDetalhes(item)"
              >
                <v-list-item-title>
                  <v-icon small>
                    mdi-file-find-outline
                  </v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item 
                @click="
                  dialogCreationLog = true,
                  dialogCreationLogData = {username: item.usuario.nome, created: item.created_at}
                "
              >
                <v-list-item-title>
                  <v-icon small>
                    mdi-table-search
                  </v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="$emit('rechargeTable')"
              >
                mdi-refresh
              </v-icon>
            </template>
            <span>Clique aqui para recarregar as projeções de brr</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete 
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">
        Deletar Projeção #{{ dialogDeleteData.id }}
      </template>
      <template slot="body">
        Tem certeza que deseja deletar a Projeção de BRR <strong>{{ dialogDeleteData.titulo }}</strong>?
      </template>
    </dialog-delete>
    <dialog-creation-log
      :dialog.sync="dialogCreationLog"
      :item="dialogCreationLogData"
    />
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes da Projeção de BRR"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="[
            {text: 'Parâmetro', value: 'parametro', sortable: false},
            {text: 'Valor', value: 'valor', sortable: false}
          ]"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td
                v-if="'arquivo_id' in row.item"
                class="download-arquivo-detalhes-click"
                @click="downloadArquivoById(row.item.arquivo_id, row.item.arquivo_nome)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-progress-circular
                        v-if="loadingDownloadArquivoById"
                        indeterminate
                        color="primary"
                        size="20"
                      />
                      <span v-else>{{ row.item.arquivo_nome }}</span>
                    </div>
                  </template>
                  <span v-if="loadingDownloadArquivoById">AGUARDE :: Baixando arquivo [{{ row.item.arquivo_nome }}]...</span>
                  <span v-else>Clique aqui para baixar o arquivo</span>
                </v-tooltip>
              </td>
              <td
                v-else-if="typeof row.item.valor === 'object' && 'logs_tecnicos' in row.item.valor"
                class="button"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ml-btn-logs"
                      icon
                      color="black"
                      :loading="loadingLogsTecnicos"
                      v-bind="attrs"
                      @click="downloadLogsTecnicos(row.item.valor.id)"
                      v-on="on"
                    >
                      <v-icon size="18">
                        mdi-file-download-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span v-if="loadingLogsTecnicos">Baixando...</span>
                  <span v-else>Clique aqui para baixar os logs técnicos</span>
                </v-tooltip>
              </td>
              <td
                v-else
                class="button"
              >
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
import ProjecaoBrrService from '@/services/ProjecaoBrrService';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
import dateFormatterMixins from '@/mixins/dateFormatterMixins';

export default {

  components: {
    GeneralStatus:         () => import('@/components/general/GeneralStatus.vue'),
    GeneralProgressBars:   () => import('@/components/general/GeneralProgressBars.vue'),
    DialogCreationLog:     () => import('@/components/general/DialogCreationLog'),
    DialogDelete:          () => import('@/components/general/DialogDelete'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
    DialogCreationLog:     () => import('@/components/general/DialogCreationLog')
  },
  mixins: [powerupsActionsMixins, dateFormatterMixins],

  props: {
    item: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    powerupService: ProjecaoBrrService,
    powerupEntityName: 'Projeção de BRR',
    search: '',
    headers: [
      {
        text: '#',
        value: 'id'
      },
      {
        text: 'Título',
        value: 'titulo'
      },
      {
        text: 'Executado',
        value: 'data_processamento'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        sortable: false,
        text: 'Ações',
        value: 'actions',
        class: 'pl-4'
      }
    ],
    loadingLogsTecnicos: false,
    dialogDelete: false,
    dialogDeleteData: {id: undefined, titulo: undefined}
  }),

  methods: {
    openDialogDetalhes(item) {
      this.dialogDetalhesData = [
        {
          parametro: 'MOVIMENTAÇÃO DA BLINDADA:',
          valor: item.movimentacoes_blindada.titulo
        },
        {
          parametro: 'SIMULAÇÃO DE LAUDO EXPRESS:',
          valor: item.simulacoes_laudos_incrementai.titulo
        },
        {
          parametro: 'PREDIÇÃO DE BAIXAS:',
          valor: item.predicoes_baixa.titulo
        },
        {
          parametro: 'ARQUIVO CAPEX:',
          arquivo_nome: item.arquivo_capex.arquivo,
          arquivo_id: item.arquivo_capex.id
        },
        {
          parametro: 'ARQUIVO CAPEX (DELIMITADOR):',
          valor: item.arquivo_capex_delimitador
        },
        {
          parametro: 'ARQUIVO CAPEX (INVOLUCRO):',
          valor: item.arquivo_capex_involucro
        },
        {
          parametro: 'ARQUIVO CAPEX (ESCAPE):',
          valor: item.arquivo_capex_escape
        }
      ];

      if (this.userIsAdmin && ['SUCESSO', 'FALHA'].includes(item.status)) {
        this.dialogDetalhesData.push(
          {parametro: ' ', valor: ' '},
          {parametro: 'LOGS TÉCNICOS:', valor: {'id': item.id, 'logs_tecnicos': true}}
        );
      }

      this.dialogDetalhes = true;
    },

    baixarLogsTecnicos(id) {
      this.loadingLogsTecnicos = true;

      ProjecaoBrrService
        .baixarLogsTecnicos(id)
        .then(res => {

          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `logs-tecnicos-projecao-brr-${id}.log`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          this.$toast.error('Falha no download dos logs técnicos.', '', { position: 'topRight' });
        })
        .finally(() => this.loadingLogsTecnicos = false);
    }
  }
};
</script>

<style>
.swithInterna label {
  font-size: 13px !important;
  margin-left: 0px !important;
}
</style>